<template>
  <div style="width: 100%; height: 100%; background-color: #fff">
    <LayoutHeader route="index" />
    <div class="module1">
      <div class="module1-content indexCenter">
        <!-- <img style="cursor: pointer;width: 630px;height: 354px;background-color: #f0f8ff;" :src="getImg(picture.url||bannerData[0].imageUrl)" @click="goDetail(picture.id, picture.type)"  :alt="picture.title"> -->

<div class="carousel-wrapper" style="width: 630px; height: 354px; background: #f5f7fa; position: relative;">
    <!-- 数据没回来时，显示 loading -->
    <div v-if="tongzhiImages.length === 0" style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;">
      <a-spin size="large" />
    </div>

        <el-carousel
          :interval="2000"
          height="354px"
          trigger="hover"
          :autoplay="true"
           v-if="tongzhiImages.length > 0"
        >
          <!-- <el-carousel-item v-for="item in carouselImages" :key="item.id"> scrollNoticeData  -->
          <el-carousel-item v-for="item in tongzhiImages" :key="item.id"> 
            <img
              :src="getImg(item.img)"
              :alt="item.title"
              style="
                width: 100%;
                height: 354px;
                object-fit: cover;
                cursor: pointer;
              "
              @click="handleCarouselClick(item)"
            />
            <div class="swiper-title">
              {{ item.title }}
            </div>
          </el-carousel-item>
        </el-carousel>
</div>

        <div class="module1-right">
          <ul class="module1-right-top">
            <li :class="{ module1LiSelect: module1Flag === 0 }">
              <div @click="module1Flag = 0">通知公告</div>
            </li>
            <li :class="{ module1LiSelect: module1Flag === 1 }">
              <div @click="module1Flag = 1">政策动态</div>
            </li>
            <li :class="{ module1LiSelect: module1Flag === 2 }">
              <div @click="module1Flag = 2">项目评审公告</div>
            </li>
          </ul>

          <ul class="module1-right-content">
            <template v-if="module1Flag === 0">
              <li
                v-for="item in scrollNoticeData"
                :key="item.id"
                @mouseenter="
                  handleMouseenter(item.picture, item.id, 1, item.title)
                "
                @click="goDetail(item.id, item.type)"
              >
                <div class="module1-title">
                  <a-tooltip>
                    <template #title>{{ item.title }}</template>
                    <p>
                      {{ item.title }}
                    </p>
                  </a-tooltip>
                  <div style="margin-left: 8px">
                    <img
                      src="../assets/svg/icon_fire.png"
                      style="vertical-align: text-bottom"
                      v-for="i in item.fire > 3 ? 3 : item.fire"
                      :key="i"
                    />
                  </div>
                </div>

                <span>{{
                  item.publishTime ? item.publishTime.split(" ")[0] : ""
                }}</span>
              </li>
            </template>
            <template v-if="module1Flag === 1">
              <li
                v-for="item in noticeData"
                :key="item.id"
                @mouseenter="
                  handleMouseenter(item.thumbnail, item.id, 2, item.title)
                "
                @click="goDetail(item.id, 2)"
              >
                <div class="module1-title">
                  <a-tooltip>
                    <template #title>{{ item.title }}</template>
                    <p>
                      {{ item.title }}
                    </p>
                  </a-tooltip>
                  <div style="margin-left: 8px">
                    <img
                      src="../assets/svg/icon_fire.png"
                      style="vertical-align: text-bottom"
                      v-for="i in item.fire > 3 ? 3 : item.fire"
                      :key="i"
                    />
                  </div>
                </div>
                <span>{{
                  item.publishTime ? item.publishTime.split(" ")[0] : ""
                }}</span>
              </li>
            </template>
            <template v-if="module1Flag === 2">
              <li
                v-for="item in projectReviewData"
                :key="item.id"
                @click="goProjectReviewDetail(item.id)"
              >
                <div class="module1-title">
                  <a-tooltip>
                    <template #title>{{ item.projectReviewName }}</template>
                    <p>
                      {{ item.projectReviewName }}
                    </p>
                  </a-tooltip>
                  <div style="margin-left: 8px">
                    <img
                      src="../assets/svg/icon_fire.png"
                      style="vertical-align: text-bottom"
                      v-for="i in item.fire > 3 ? 3 : item.fire"
                      :key="i"
                    />
                  </div>
                </div>
                <span>{{
                  item.auditTime ? item.auditTime.split(" ")[0] : ""
                }}</span>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>

    <div class="module2">
      <div class="module2-content indexCenter">
        <div class="module-title">
          <div class="module-title-left">企业服务</div>
        </div>

        <!-- Swiper 轮播容器 -->
<!-- 只保留一个代理点击事件在 service-swiper 上 -->
<div class="service-swiper" @click="handleSwiperClick">
  <div class="swiper-wrapper">
    <div
      class="swiper-slide"
      v-for="(item, index) in items"
      :key="`service_${index}`"
      :data-index="index"
    >
      <div class="module2-item">
        <img :src="item.img" :alt="item.title" />
        <div class="item-btm">
          <div class="item-title">{{ item.title }}</div>
          <p class="item-text" v-html="item.desc"></p>
          <div class="item-btn">
            <a-button>点击进入</a-button>   <!-- 移除 @click -->
          </div>
          <div class="item-btn2">
            <a-button v-if="item.btn1">{{ item.btn1 }}</a-button>   <!-- 移除 @click -->
            <a-button v-if="item.btn2">{{ item.btn2 }}</a-button>   <!-- 移除 @click -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- 左右切换箭头 -->
<div class="carousel-arrow prev-arrow service-arrow-prev"></div>
<div class="carousel-arrow next-arrow service-arrow-next"></div>
      </div>
    </div>

    <div class="module3">
      <div class="module3-content indexCenter">
        <div class="module-title">
          <div class="module-title-left">双创公共服务统计</div>
        </div>
        <div class="module3-content-box">
          <div class="module3-item">
            <img src="@/assets/home/module3-icon01.png" alt="" />
            <div class="item-right">
              <div class="module3-num">
                <div class="right-num">{{ fourObj.companyCount }}</div>
                <span>家</span>
              </div>
              <p>入驻企业</p>
            </div>
          </div>
          <div class="module3-item">
            <img src="@/assets/home/module3-icon02.png" alt="" />
            <div class="item-right">
              <div class="module3-num">
                <div class="right-num">{{ fourObj.baseCount }}</div>
                <span>个</span>
              </div>
              <p>基地数量</p>
            </div>
          </div>
          <div class="module3-item">
            <img src="@/assets/home/module3-icon03.png" alt="" />
            <div class="item-right">
              <div class="module3-num">
                <div class="right-num">
                  {{ fourObj.intellectualPropertyCount }}
                </div>
                <span>件</span>
              </div>
              <p>知识产权</p>
            </div>
          </div>
          <div class="module3-item">
            <img src="@/assets/home/module3-icon04.png" alt="" />
            <div class="item-right">
              <div class="module3-num">
                <div class="right-num">
                  {{ fourObj.highTechEnterpriseCount }}
                </div>
                <span>家</span>
              </div>
              <p>高新技术企业</p>
            </div>
          </div>
          <div class="module3-item">
            <img src="@/assets/home/module3-icon05.png" alt="" />
            <div class="item-right">
              <div class="module3-num">
                <div class="right-num">{{ fourObj.technologySmesCount }}</div>
                <span>家</span>
              </div>
              <p>科技型中小企业</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="module4">
      <div class="module4-content indexCenter">
        <div class="module-title">
          <div class="module-title-left">创新服务</div>
          <!-- <div class="module-title-right">查看更多<RightOutlined /></div> -->
        </div>

        <div class="menuBox">
          <div
            class="smallMenuBox"
            @click="goMoreNotice('/Innovation/index', { type: '首页' })"
          >
            <img
              src="@/assets/home/module4-icon01.png"
              alt=""
              class="module4-img"
            />
            <img
              src="@/assets/home/module4-icon01s.png"
              alt=""
              class="module4-imgs"
            />
            <div class="menuTitle">创新创业</div>
            <div class="titleInfo">增创发展新优势</div>
            <div class="showMoreBtn">
              <a-button>点击进入</a-button>
            </div>
          </div>
          <!--  @click="goMore('/achievements/index')" -->
          <div class="smallMenuBox" @click="goMore('/achievements/index')">
            <img
              src="@/assets/home/module4-icon02.png"
              alt=""
              class="module4-img"
            />
            <img
              src="@/assets/home/module4-icon02s.png"
              alt=""
              class="module4-imgs"
            />
            <div class="menuTitle">成果转化</div>
            <div class="titleInfo">汇聚创新好项目</div>
            <div class="showMoreBtn">
              <a-button>点击进入</a-button>
            </div>
          </div>
          <!--  @click="goMore('/knowledge/index')" -->
          <div class="smallMenuBox" @click="goMore('/knowledge/index')">
            <img
              src="@/assets/home/module4-icon03.png"
              alt=""
              class="module4-img"
            />
            <img
              src="@/assets/home/module4-icon03s.png"
              alt=""
              class="module4-imgs"
            />
            <div class="menuTitle">知识产权</div>
            <div class="titleInfo">高质量专利数据</div>
            <div class="showMoreBtn">
              <a-button>点击进入</a-button>
            </div>
          </div>
          <div class="smallMenuBox" @click="goMore('/finance/index')">
            <img
              src="@/assets/home/module4-icon04.png"
              alt=""
              class="module4-img"
            />
            <img
              src="@/assets/home/module4-icon04s.png"
              alt=""
              class="module4-imgs"
            />
            <div class="menuTitle">科技金融</div>
            <div class="titleInfo">专业金融管理</div>
            <div class="showMoreBtn">
              <a-button>点击进入</a-button>
            </div>
          </div>
          <!-- goHttp('https://www.yqgxqsc.com/talent/#/home') -->
          <div class="smallMenuBox">
            <img
              src="@/assets/home/module4-icon05.png"
              alt=""
              class="module4-img"
            />
            <img
              src="@/assets/home/module4-icon05s.png"
              alt=""
              class="module4-imgs"
            />
            <div class="menuTitle">科技人才</div>
            <!--            <div class="titleInfo">成功需要不断突破</div>-->
            <div class="titleInfo">联系电话：0353-2292345</div>
            <div class="showMoreBtn">
              <a-button @click="goHttp('https://www.yqgxqsc.com/talent/#/home')"
                >点击进入</a-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="linkBig" v-if="false">
      <div class="linkBox">
        <div class="leftLabel">友情链接</div>
        <div class="rightBox">
          <div v-for="item in linkData" :key="item.id">
            <a target="_blank" :href="item.furl" class="itemLink">{{
              item.fname
            }}</a>
          </div>
        </div>
      </div>
    </div>
    <LayoutFooter />
    <!-- <div class="fixBox" v-if="showPolicy">
      <div class="box">
        <div class="Xbtn" @click="showPolicy = false">X</div>
        <div class="title" @click="goPolicyNoticeDetail(policyNotice)">
          {{ policyNotice.title }}
        </div>
        <div
          class="dataTime"
          @click="goPolicyNoticeDetail(policyNotice)"
          v-if="policyNotice.startTime && policyNotice.endTime"
        >
          申报时间：{{
            policyNotice.startTime && policyNotice.startTime.split(" ")[0]
          }}
          ~ {{ policyNotice.endTime && policyNotice.endTime.split(" ")[0] }}
        </div>
        <a-button
          style="
            color: #1890ff;
            font-weight: 600;
            padding: 0 15px;
            border: none;
            font-size: 14px;
            text-align: right;
          "
          @click="goPolicyNoticeDetail(policyNotice)"
          >去申报</a-button
        >
        <img src="@/assets/img/policy.jpg" alt="">
      </div>
    </div> -->
    <!-- 飘窗 -->
    <!-- <Baywindow v-if="showPolicy" :policyNotice="policyNotice"></Baywindow> -->
    <a-modal
      v-model:visible="visible"
      :maskClosable="false"
      :closable="false"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      上一年度营业收入规模(万元)：
      <a-input-number
        style="width: 100%; margin-top: 20px"
        v-model:value="operatingIncomeScale"
        :min="1"
        placeholder="请输入上一年度营业收入规模(万元)"
      />
      <pre style="color: red">
				*请认真核查填报的{{ nowYear - 1 }}年度营业收入数据，若数据填报错误，积分表单未
				提交状态可以选中表单删除重新填报。若数据已提交则需要平台方审核不通
				过方可删除数据重新填报。
				种子期0万(含)-100万
				初创期100万(含)-500万
				成长期500万(含)-2000万
				成熟期2000万(含)以上</pre
      >
    </a-modal>

    <a-modal
      v-model:visible="chapterShow"
      title="刻章服务"
      class="seal-carving"
    >
      <div style="width: 100%; height: 260px; position: relative">
        <div
          ref="SealServiceShow"
          style="
            position: absolute;
            margin: 0 auto;
            text-align: center;
            background: #fff;
          "
          :class="{ SealServiceActive: SealServiceShow == 1 }"
        >
          <!-- EnterpriseSealServiceLogin -->
          <a-modal
            v-model:visible="isShow"
            title="请填写当前计算式的答案"
            @ok="valiKaptcha"
          >
            <img style="float: left" @click="subPhone" :src="kaptcha" alt="" />
            <a-input
              style="
                width: 120px;
                margin-left: 50px;
                font-size: 22px;
                height: 50px;
              "
              v-model:value="kaptchanum"
              placeholder="答案"
            />
          </a-modal>
          <a-form
            v-if="SealServiceShow == 1"
            class="login-form"
            ref="ruleForm"
            layout="horizontal"
            :model="form"
            :rules="rules"
          >
            <div class="tipphone">
              <p>详情请咨询：0353-2292800/0353-2292128</p>
            </div>

            <a-col v-if="valiJWTShow" :span="20">
              <a-form-item
                :label-col="{ style: 'width:90px' }"
                name="phoneNumber"
                label="手机号"
              >
                <a-input
                  style="position: relative;"
                  v-model:value="form.phoneNumber"
                  placeholder="请输入手机号"
                >
                  <template #prefix>
                    <PhoneOutlined class="tc-gray" />
                  </template>
                  <template #addonAfter>
                    <a-botton style="cursor: pointer" @click="subPhone()">{{
                      codeBtnWord
                    }}</a-botton>
                    <div class="codeBtnWordMark" ref="codeBtnWordMarkid"></div>
                  </template>
                </a-input>
              </a-form-item>
            </a-col>

            <a-col v-if="valiJWTShow" :span="20">
              <a-form-item
                :label-col="{ style: 'width:120px;margin-left:-30px' }"
                name="watmal"
                label="手机验证码"
              >
                <a-input
                  style="margin-right: 20px"
                  v-model:value="form.watmal"
                  placeholder="请输入手机验证码"
                >
                  <template #prefix>
                    <LockOutlined class="tc-gray" />
                  </template>
                  <template #addonAfter> </template>
                </a-input>
              </a-form-item>
            </a-col>
          </a-form>

          <div v-if="!valiJWTShow">账号：{{ form.phoneNumber }}</div>
        </div>
      </div>

      <template #footer>
        <template v-if="valiJWTShow">
          <a-button
            style="margin-right: 20px"
            @click="SealPost(1, 'SealService')"
            >去刻章</a-button
          >
          <a-button
            style="margin-right: 20px"
            @click="SealPost(2, 'SealService')"
            >查询</a-button
          >
          <a-button
            @click="
              chapterShow = false;
              SealServiceShow = 0;
              form.phoneNumber = null;
              form.watmal = null;
            "
            >取消</a-button
          >
        </template>
        <template v-else>
          <a-button
            style="margin-right: 20px; margin-left: 50px; margin-bottom: 24px"
            @click="SealPost(1, 'SealService')"
            >去刻章</a-button
          >
          <a-button
            style="margin-right: 20px"
            @click="SealPost(2, 'SealService')"
            >查询</a-button
          >
          <a-button
            style="margin-right: 20px"
            @click="
              chapterShow = false;
              SealServiceShow = 0;
              form.phoneNumber = null;
              form.watmal = null;
            "
            >取消</a-button
          >
          <a-button @click="delJWT()">退出</a-button>
        </template>
      </template>
    </a-modal>

    <div class="rightNav">
      <div class="rightNav-item">
        <img
          src="@/assets/img/rightNav-icon01.png"
          alt=""
          class="rightNav-img"
        />
        <img
          src="@/assets/img/rightNav-icon01s.png"
          alt=""
          class="rightNav-imgs"
        />
        <p>掌上服务</p>

        <div class="rightNav-mask">
          <div class="right-code-item">
            <img :src="getImg(webSiteInfo.siteBarCode2)" alt="" />
            <p>科技创新中心</p>
          </div>
          <div class="right-code-item" style="margin-left: 32px">
            <img :src="getImg(webSiteInfo.siteBarCodes)" alt="" />
            <p>阳泉高新区</p>
          </div>
        </div>
      </div>
      <div class="rightNav-item">
        <img
          src="@/assets/img/rightNav-icon02.png"
          alt=""
          class="rightNav-img"
        />
        <img
          src="@/assets/img/rightNav-icon02s.png"
          alt=""
          class="rightNav-imgs"
        />
        <p>联系电话</p>

        <div class="rightNav-mask">
          <p>联系电话：{{ webSiteInfo.phone }}</p>
        </div>
      </div>
      <div class="rightNav-item" @click="scrollToTop">
        <img
          src="@/assets/img/rightNav-icon03.png"
          alt=""
          class="rightNav-img"
        />
        <img
          src="@/assets/img/rightNav-icon03s.png"
          alt=""
          class="rightNav-imgs"
        />
        <p>返回顶部</p>
      </div>
    </div>
  </div>
</template>

<script>
import { phoneCommon } from "@/api/finance";
import { message, notification } from "ant-design-vue";
import { dictMixin } from "@/mixins";
import {
  file_service,
  kaptcha,
  login_mp,
  noticeInfoHome,
  sys_admin,
  sys_policyNotice,
} from "@/api/adminService";
import dataCheck from "@/utils/dataCheck";
import { ls } from "@/utils/util";
import { enterpriseOperatingIncome } from "@/api/integral";
import { jwtToken } from "@/api/materializePolicy";
import { applicationIndex } from "@/api/projectReviewService";
import {
  getBannerInfo,
  getWebInfo,
  getWLinkPage,
  noticeInfo,
} from "@/api/homeService";
import { platformName } from "@/config/platformConfig";
import DictRender from "@/components/other/DictRender";
import LayoutHeader from "@/layout/layoutPage/header/LayoutHeaderNew2";
import LayoutFooter from "@/layout/layoutPage/footer/LayoutFooterNew2";
import axios from "axios";


import Swiper, { Navigation, Autoplay } from 'swiper'
import 'swiper/swiper-bundle.css'
Swiper.use([Navigation, Autoplay])

export default {
  name: "indexBack",
  components: {
    LayoutFooter,
    DictRender,
    LayoutHeader,
    // Baywindow
  },
  mixins: [dictMixin],
  data() {
    return {
      picture: {},
      kaptcha: null,
      kaptchanum: null,
      valiJWTShow: true,
      isShow: false,
      de1: null,
      de2: null,
      SealServiceShow: 0,
      materializePolicyShow: 0,
      codeBtnWord: "获取短信验证码",
      startLogin: true,
      nowYear: new Date().getFullYear(),
      all_logo: "",
      dictNames: "policy_type,message_type",
      noticeData: [],
      TongzhiData:[],
      scrollNoticeData: [],
      projectReviewData: [],
      fourObj: {},
      user: {},
      getDetailNoteParam: null,
      operatingIncomeScale: null,
      platformName,
      getAuditStatus: null,
      visible: false,
      getDateId: null,
      formState: {
        user: undefined,
      },
      form: {
        phoneNumber: null,
        watmal: null,
      },
      rules: {
        phoneNumber: [
          dataCheck.required({ msg: "手机号不能为空" }),
          dataCheck.mobile_phone,
        ],
        watmal: [dataCheck.required({ msg: "验证码不能为空" })],
      },
      policyNotice: {},
      showPolicy: true,
      bannerData: [],
      webSiteInfo: {},
      linkData: [],
      // selectOption: [
      // 	{ label: '种子期(0（含）—100万元)', value: 1 },//seed
      // 	{ label: '初创期(100（含）—500万元)', value: 2 },//newly
      // 	{ label: '成长期(500（含）—2000万元)', value: 3 },//growth
      // 	{ label: '成熟期(2000（含）以上万元)', value: 4 }, //maturation
      // ],

      module1Flag: 0,
      chapterShow: false,
      swiperInstance:null,
items: [
  {
    img: require("@/assets/home/module2-01.jpg"),
    title: "企业创新积分制",
    desc: "量化企业创新能力，积分与政策扶持、金融支持挂钩，激励企业加大创新投入。",
    btn1: "积分填报",
    btn1Type: "integralPost", // 换成动作类型标识
    btn2: "企业积分制中心",
    btn2Type: "goMore",       // 动作类型
    btn2Path: "/integral"     // 动作所需参数
  },
  {
    img: require("@/assets/home/module2-02.jpg"),
    title: "信息化项目评审",
    desc: "提供全流程评审服务，涵盖项目申报、专家评审、结果公示...",
    btn1: "点击进入",
    btn1Type: "goProjectReview"
  },
  {
    img: require("@/assets/home/module2-03.jpg"),
    title: "政策兑现",
    desc: "整合各级各类惠企政策，明确兑换条件、流程与标准，企业线上...",
    btn1: "点击进入",
    btn1Type: "goMore",
    btn1Path: "/materializePolicy/Add"
  },
  {
    img: require("@/assets/home/module2-04.jpg"),
    title: "新办经营主体刻章服务",
    desc: `<div style="width: 100%">联系电话：0353-2292800</div><div style="width: 100%;margin-left: 80px">0353-2292128</div>`,
    btn1: "去刻章",
    btn1Type: "valiJWT"
  },
  {
    img: require("@/assets/home/module2-05.jpg"),
    title: "企静通",
    desc: "规范涉企执法检查行为，精简频次流程，维护营商环境及合法权益。",
    btn1: "点击进入",
    btn1Type: "openUrl",
    btn1Url: "https://www.yqgxqsc.com/quiet/#/index"
  },
  {
    img: require("@/assets/home/module2-06.jpg"),
    title: "绩效考核管理",
    desc: "统一评价标尺，甄别绩效差异，配套奖惩培养，提升组织竞争力。",
    btn1: "点击进入",
    btn1Type: "openUrl",
    btn1Url: "https://www.yqgxqsc.com/jxkh/index"
  },
],
    };
  },
  computed: {
    tongzhiImages(){
      let arrList = []
      if(Array.isArray(this.TongzhiData)){
   this.TongzhiData.forEach((item) => {
        if (item.picture) {
          arrList.push({
            img: item.picture,
            id: item.id,
            type: 1,
            title: item.title,
          });
        }
      });
      }
    
      arrList = arrList.slice(0, 6);    
      return arrList;
  },
    carouselImages() {
      const arr = [];  
      this.scrollNoticeData.forEach((item) => {
        if (item.picture) {
          arr.push({
            img: item.picture,
            id: item.id,
            type: 1,
            title: item.title,
          });
        }
      });
      this.noticeData.forEach((item) => {
        if (item.thumbnail) {
          arr.push({
            img: item.thumbnail,
            id: item.id,
            type: 2,
            title: item.title,
          });
        }
      });
      this.projectReviewData.forEach((item) => {
        if (item.picture) {
          arr.push({
            img: this.getImg(item.picture), // 用 getImg 处理
            id: item.id,
            type: 3,
            title: item.projectReviewName,
          });
        }
      });

      // 没有图片时，默认用 bannerData[0].imageUrl
      // getImg(picture.url||bannerData[0].imageUrl)
      if (
        arr.length === 0 &&
        this.bannerData &&
        this.bannerData.length > 0 &&
        this.bannerData[0].imageUrl
      ) {
        arr.push({
          img: this.getImg(this.bannerData[0].imageUrl), // 用 getImg 处理
          id: 1,
          type: 4,
          title: "",
          isDefault: true,
        });
      }
      console.log(this.bannerData[0].imageUrl, "222222222222");
      return arr;
    },
  },

  created() {
    this.getWebInfo();
    // eslint-disable-next-line no-mixed-spaces-and-tabs
    // alert("系统已迁移至域名访问，请访问：https://www.yqgxqsc.com")
  },
  methods: {
// 通知公告的数据
async getTongzhi(){
  let res = await this.getAction({
        url: noticeInfoHome.pageList,
        params: { pageNum: 1, pageSize: 100 },
  })
  this.TongzhiData = res.records;
console.log('[ this.TongzhiData ] >', this.TongzhiData)
},
     // 新增：事件代理
  handleSwiperClick(e) {
    // 获取实际点击的按钮元素
    const btn = e.target.closest('.ant-btn');
    if (!btn) return; // 点击的不是按钮

    // 获取按钮所在的 slide
    const slide = btn.closest('.swiper-slide');
    if (!slide) return;

    // 获取 slide 上存储的索引
    const index = slide.dataset.index;
    if (index === undefined) return;

    const item = this.items[index];
    if (!item) return;

    // 判断点击的是哪个按钮（btn1 还是 btn2）
    const btnText = btn.innerText.trim();
    let btnType = null;
    if (btnText === item.btn1) {
      btnType = 'btn1';
    } else if (btnText === item.btn2) {
      btnType = 'btn2';
    } else {
      // 可能是“点击进入”按钮，默认使用 btn1
      btnType = 'btn1';
    }

    console.log('代理点击:', item.title, btnType);
    this.handleItemClick(item, btnType);
  },

    // 新增：统一处理轮播内的按钮点击
handleItemClick(item, btnType) {
  console.log('轮播按钮点击:', item, btnType);
  const actionType = item[`${btnType}Type`];
  const path = item[`${btnType}Path`];
  const url = item[`${btnType}Url`];

  // 根据动作类型执行对应逻辑（this指向正确的组件实例）
  switch(actionType) {
    case 'integralPost':
      this.integralPost();
      break;
    case 'goProjectReview':
      this.goProjectReview();
      break;
    case 'goMore':
      this.goMore(path || '', '', '');
      break;
    case 'valiJWT':
      this.valiJWT();
      break;
    case 'openUrl':
      window.open(url, "_blank");
      break;
    default:
      console.warn('未定义的动作类型:', actionType);
  }
},
initSwiper() {
  if (document.querySelector('.service-swiper')) {
    this.swiperInstance = new Swiper(".service-swiper", {
      modules: [Navigation, Autoplay],
      slidesPerView: "auto",
      spaceBetween: 20,
      // 核心：关闭所有点击阻止
      preventClicks: false,
      preventClicksPropagation: false,
      touchStartPreventDefault: false,
      // 监听元素变化，解决动态数据问题
      observer: true,
      observeParents: true,
      // 绑定自定义箭头
      navigation: {
        nextEl: '.service-arrow-next',
        prevEl: '.service-arrow-prev',
      },
      autoplay:{
        delay:10000,
        disableOnInteraction:false
      },
      loop:true,
    });
  }
},

    handleCarouselClick(item) {
      if (item.type === 1 || item.type === 2) {
        this.goDetail(item.id, item.type);
      } else if (item.type === 3) {
        this.goProjectReviewDetail(item.id);
      } else if (item.type === 4) {
        this.$router.push({ path: "/notice", query: { type: 1 } }); // 跳转并传递type=1
      }
    },
    handleMouseenter(pic, id, type, title) {
      this.picture.url = pic;
      this.picture.id = id;
      this.picture.type = type;
      this.picture.title = title;
    },
    goProjectReview() {
      console.log(3333333);

      this.goMore("/projectReview");
      /*if (ls.get('token') && ls.get("refresh_token")){
                this.goMore("/projectReview")
            }else{
                this.goMoreNotice('/register',{role:'014'})
            }*/
    },
    getPhoneCode() {
      this.$refs.ruleForm.validate("phoneNumber").then((value) => {
        this.postAction({
          url: phoneCommon.sealSMS,
          params: {
            phone: value.phoneNumber,
          },
        }).then((res) => {
          if (res.code == "0") {
            this.waitTime = res.msg * 60 + 1;
            this.waitTime--;
            this.$refs.codeBtnWordMarkid.style.zIndex = 1;
            this.codeBtnWord = `${this.waitTime}s 后获取`;
            let timer = setInterval(() => {
              if (this.waitTime > 1) {
                this.waitTime--;
                this.codeBtnWord = `${this.waitTime}s 后获取`;
              } else {
                clearInterval(timer);
                this.codeBtnWord = "获取短信验证码";
                this.$refs.codeBtnWordMarkid.style.zIndex = -1;
                this.waitTime = 61;
              }
            }, 1000);
            notification.success({
              message: "验证码发送成功，请查看手机短信",
              style: {
                width: "400px",
                fontWeight: "600",
                marginLeft: `${-200}%`,
                marginTop: `${20}%`,
              },
            });
          } else if (res.code == "1") {
            notification.success({
              message: "验证码发送失败，请稍后重新发送",
              style: {
                width: "400px",
                fontWeight: "600",
                marginLeft: `${-200}%`,
                marginTop: `${20}%`,
              },
            });
          } else if (res.code == "2") {
            notification.success({
              message: res.msg,
              style: {
                width: "400px",
                fontWeight: "600",
                marginLeft: `${-200}%`,
                marginTop: `${20}%`,
              },
            });
          } else if (res.code == "3") {
            notification.success({
              message: res.msg,
              style: {
                width: "400px",
                fontWeight: "600",
                marginLeft: `${-200}%`,
                marginTop: `${20}%`,
              },
            });
          }
        });
      });
    },
    logout() {
      let self = this;

      self.$ls.clear();
      self.$store.commit("setMenuData", []);
      self.$router.replace("/");

      location.reload();
    },
    onLogout() {
      let self = this;
      self.$confirm({
        title: "确认要退出登录?",
        content: "",
        onOk() {
          self
            .postAction({
              url: login_mp.saveLog,
              params: { logAppCategoryEnum: "LOGOUT" },
            })
            .then((res) => {
              console.log(res);
              self
                .getAction({
                  url: login_mp.logout,
                  params: { access_token: ls.get("token") || "" },
                  isValid: false,
                })
                .then(() => {
                  self.$notification["success"]({
                    message: "退出成功",
                    style: {
                      fontWeight: "600",
                    },
                  });
                });
            });

          setTimeout(() => {
            self.logout();
          }, 2000);
        },
        onCancel() {},
      });
    },
    getPolicyNotice() {
      this.getAction({
        url: sys_policyNotice.pageList,
        params: { noticeType: "3" },
      }).then((res) => {
        if (res.records.length > 0) {
          let obj = res.records[0];
          if (obj.sendStatus == 0 && obj.endTime) {
            // 获取当前日期和时间
            const currentDate = new Date().toLocaleDateString();

            // 创建一个包含当前日期和时间的 Date 对象
            const todayDate = new Date(obj.endTime);

            // 计算两个 Date 对象之间的天数差
            const daysBetween =
              new Date(todayDate).getTime() - new Date(currentDate).getTime();
            // 如果当前日期超过今天，则打印提示信息
            if (daysBetween > 0) {
              this.showPolicy = true;
              this.policyNotice = obj;
            } else {
              this.showPolicy = false;
            }
          }
          if (!obj.endTime && obj.sendStatus == 0) {
            this.showPolicy = true;
            this.policyNotice = obj;
          }
        } else {
          this.showPolicy = false;
        }
      });
    },
    goPolicyNoticeDetail(record) {
      if (ls.get("token") && ls.get("refresh_token")) {
        if (ls.get("roleCode").includes("company")) {
          if (record.title.indexOf("积分制") > 0) {
            this.$router.push({ path: "/sys/manage" });
          } else if (record.title.indexOf("政策兑现") > 0) {
            this.$router.push({ path: "/sys/policyPublicData" });
          }
        } else {
          this.$router.push({
            path: "/noticeDetail",
            query: { id: record.id, source: "piao" },
          });
        }
      } else {
        this.goMore("/login", "user");
      }

      // this.$router.push({
      //   path: "/noticeDetail",
      //   query: { id: id, source: 'piao' }
      // })
    },
    goMorePolicy(type) {
      this.$router.push({
        path: "/notice",
        query: { type: type },
      });
    },
    goMoreProjectReview() {
      this.$router.push({
        path: "/projectReview",
        query: {},
      });
    },
    goDetail(id, type) {
      if (type === 3) {
        this.goProjectReviewDetail(id);
        return;
      }
      this.$router.push({
        path: "/noticeDetail",
        query: { id: id, type: type },
      });
    },
    goProjectReviewDetail(id) {
      this.$router.push({
        path: "/projectReviewDetail",
        query: { id: id },
      });
    },
    getUserInfo() {
      this.getAction({
        url: sys_admin.userInfor,
      }).then((res) => {
        sessionStorage.setItem("roleCode", res.roleCode.split(","));
      });
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    getNoticeInfo() {
      this.getAction({
        url: noticeInfo.pageList,
        params: { pageNum: 1, pageSize: 6 },
      }).then((res) => {
        this.noticeData = res.records;
        this.getProjectReviewList();
        console.log(this.noticeData, "政策动态");
      });
    },
    getNoticeDownInfo() {
      this.getAction({
        url: noticeInfoHome.pageList,
        params: { pageNum: 1, pageSize: 6 },
      }).then((res) => {
        this.scrollNoticeData = res.records;
        let articles = new Array();
        for (let project of this.noticeData) {
          project.type = 2;
          articles.push(project);
        }
        for (let project of this.projectReviewData) {
          project.type = 3;
          project.publishTime = project.auditTime;
          project.title = project.projectReviewName;
          articles.push(project);
        }
        for (let project of res.records) {
          project.type = 1;
          articles.push(project);
        }
        // 倒序排序（置顶优先，然后按时间）
        articles.sort((a, b) => {
          // 置顶的排在前面
          if ((a.isTop || 0) !== (b.isTop || 0)) {
            return (b.isTop || 0) - (a.isTop || 0);
          }
          // 按置顶排序值
          if ((a.topSort || 0) !== (b.topSort || 0)) {
            return (b.topSort || 0) - (a.topSort || 0);
          }
          // 按时间
          const dateA = new Date(("" + a.publishTime).replace(" ", "T"));
          const dateB = new Date(("" + b.publishTime).replace(" ", "T"));
          return dateB - dateA;
        });
        console.log("articles-----------------------------------------------");
        console.log(articles);
        this.scrollNoticeData = [];
        for (let i = 0; i < 6; i++) {
          this.scrollNoticeData.push(articles[i]);
        }
        console.log(this.scrollNoticeData, "通知公告");
      });
    },
    getProjectReviewList() {
      this.getAction({
        url: applicationIndex.notLoginPage,
        params: { pageNum: 1, pageSize: 6 },
      }).then((res) => {
        this.projectReviewData = res.records;
        this.getNoticeDownInfo();
        console.log(this.projectReviewData, "项目评审公告");
      });
    },
    getFourData() {
      this.getAction({
        url: noticeInfo.fourData,
      }).then((res) => {
        // console.log(res)
        this.fourObj = res;
      });
    },
    goHttp(url) {
      window.open(url, "_blank");
    },
    // goMore(url, str, gourl) {
    //   console.log('[ 22222222 ] >', 22222222)
    //   this.$router.push({ path: url, query: { id: str, gourl: gourl } });
    // },
    goMore(url, str, gourl) {
  console.log('[ 跳转参数 ]', url, str, gourl);
  if (!url) {
    console.error('跳转路径不能为空');
    return;
  }
  this.$router.push({
    path: url,
    query: { id: str, gourl: gourl }
  })
  .then(() => console.log('跳转成功'))
  .catch(err => console.error('跳转失败:', err));
},
    goMoreNotice(url, str) {
      this.$router.push({ path: url, query: { ...str } });
    },
    getDetail() {
      this.getAction({
        url: enterpriseOperatingIncome.detail,
        params: {
          id: this.getDateId.id,
        },
        returnMsg: true,
      }).then((res) => {
        this.getDetailNoteParam = res.data;
        this.operatingIncomeScale = res.data.operatingIncomeScale;
        this.getAuditStatus = res.data.auditStatus;
      });
    },
    getDate() {
      if (ls.get("token")) {
        this.startLogin = false;
      } else {
        this.startLogin = true;
      }
      this.getAction({
        url: enterpriseOperatingIncome.getDate,
        returnMsg: true,
      }).then((res) => {
        this.getDateId = res.data;
      });
    },
    islogin() {
      if (ls.get("token") && ls.get("refresh_token")) {
        if (ls.get("roleCode").includes("company")) {
          this.goMore("/sys/userIndex");
        } else if (ls.get("roleCode").includes("technicalManager")) {
          this.goMore("/sys/technology/person");
        } else if (ls.get("roleCode").includes("serviceOrganization")) {
          this.goMore("/sys/innovation/organization/index");
        } else if (ls.get("roleCode").includes("investorManager")) {
          this.goMore("/finance/investorInformation");
        } else if (ls.get("roleCode").includes("investmentMechanism")) {
          this.goMore("/finance/investmentOrganizationInformation");
        } else if (ls.get("roleCode").includes("financialAdviser")) {
          this.goMore("/finance/financialAdvisorInformation");
        } else if (ls.get("roleCode").includes("bank")) {
          this.goMore("/finance/financingInstitutionInformation");
        } else if (ls.get("roleCode").includes("expert")) {
          this.goMore("/sys/userIndex");
        } else if (ls.get("roleCode").includes("gov-institution")) {
          this.goMore("/sys/govInstitution");
        } else {
          this.goMore("/sys/userInfo");
        }
      } else {
        this.goMore("/login", "user");
      }
    },
    /**
     * @description: 防机器刷，并获取验证码
     * @return {*}
     */
    subPhone() {
      axios({
        method: "get",
        url: kaptcha.generatekaptcha,
        responseType: "blob",
        params: {
          phone: this.form.phoneNumber,
        },
      }).then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        this.kaptcha = window.URL.createObjectURL(blob);
        this.isShow = true;
      });
    },
    valiKaptcha() {
      // this.subPhone()
      axios({
        method: "get",
        url: kaptcha.verifykaptcha,
        params: {
          phone: this.form.phoneNumber,
          num: this.kaptchanum,
        },
      }).then((res) => {
        if (res.data.data) {
          this.isShow = false;
          this.getPhoneCode();
        } else {
          this.subPhone();
          message.warning("请重新计算，答案错误");
        }
      });
    },

    /**
     * @description: 校验JWT
     * @return {*}
     */
valiJWT() {
  console.log('[ 45454 ] >', 4545);
  const jwtphone = ls.get("jwtphone");
  const jwtMain = ls.get("jwtMain");

  console.log("jwtphone:", jwtphone, "jwtMain:", jwtMain); // 打印参数，确认是否为空

  this.getAction({
    url: jwtToken.JwtCheck,
    params: {
      phone: jwtphone,
      jwt: jwtMain,
    },
  }).then((res) => {
    console.log("接口返回 res:", res, 1442);
    this.chapterShow = true; // 无论 res 是什么，先显示弹框
    if (res) {
      this.valiJWTShow = false;
      this.SealServiceShow = 1;
      this.form.phoneNumber = jwtphone;
    } else {
      this.valiJWTShow = true;
      this.SealServiceShow = 1;
      this.form.watmal = null;
      this.form.phoneNumber = null;
    }
  }).catch((err) => {
    console.error("JWT校验接口失败:", err); // 捕获错误
    this.chapterShow = true; // 即使接口失败，也显示弹框，让用户重新输入
    this.valiJWTShow = true;
    this.SealServiceShow = 1;
    this.form.watmal = null;
    this.form.phoneNumber = null;
  });
},

    /**
     * @description: 获取JWT
     * @param {*} m
     * @return {*}
     */
    getJWT(n) {
      this.getAction({
        url: jwtToken.phoneGetJwt,
        params: {
          phone: ls.get("jwtphone"),
        },
      }).then((res) => {
        if (res) {
          ls.set("jwtMain", res);
          setTimeout(() => {
            if (n == 1) {
              this.goMore(
                "/EnterpriseSealService/Add",
                this.form.phoneNumber,
                "add"
              );
            } else if (n == 2) {
              this.goMore(
                "/EnterpriseSealService",
                this.form.phoneNumber,
                "list"
              );
            }
          }, 50);
        }
      });
    },
    delJWT() {
      this.getAction({
        url: jwtToken.jwtQuit,
        params: {
          phone: ls.get("jwtphone"),
        },
      }).then((res) => {
        if (res) {
          this.chapterShow = false;
          this.SealServiceShow = 0;
          this.form.phoneNumber = null;
          this.form.watmal = null;
          ls.set("jwtphone", "");
          ls.set("jwtMain", "");
          this.$notification.success({
            message: "退出成功",
            duration: 10,
            style: {
              width: "400px",
              fontWeight: "600",
              marginTop: `${10}%`,
            },
          });
        }
      });
    },
    SealPost(n) {
      if (this.valiJWTShow) {
        var valiSome = ["watmal", "phoneNumber"];
        this.$refs.ruleForm.validate(valiSome).then(() => {
          this.postAction({
            url: phoneCommon.sealSMSCheck,
            params: {
              code: this.form.watmal,
              phone: this.form.phoneNumber,
            },
          }).then((res) => {
            if (res) {
              this.$notification.success({
                message: "验证码正确，请继续操作",
                duration: 10,
                style: {
                  width: "400px",
                  fontWeight: "600",
                  marginTop: `${10}%`,
                },
              });

              ls.set("jwtphone", this.form.phoneNumber);
              this.getJWT(n);
            } else {
              this.$notification.error({
                message: "验证码有误，请输入正确验证码",
                duration: 10,
                style: {
                  width: "400px",
                  fontWeight: "600",
                  marginTop: `${10}%`,
                },
              });
            }
          });
        });
      } else {
        if (n == 1) {
          this.goMore(
            "/EnterpriseSealService/Add",
            this.form.phoneNumber,
            "add"
          );
        } else if (n == 2) {
          this.goMore("/EnterpriseSealService", this.form.phoneNumber, "list");
        }
      }
    },
    integralPost() {
      console.log(11111111111);

      // if (this.getDateId.etype) {
      // 	this.$notification.warning({
      // 		message: '不在填报时间内',
      // 		style: {
      // 			fontWeight: '600',
      // 		},
      // 	});
      // } else {
      // 	if (ls.get('token') && ls.get("refresh_token")) {
      // 		this.goMore('/sys/manage')
      // 	} else {
      // 		this.goMore('/login', 'user', true)
      // 	}
      // }
      if (ls.get("token") && ls.get("refresh_token")) {
        if (ls.get("roleCode").includes("company")) {
          this.goMore("/sys/manage");
        } else {
          this.$notification.warning({
            message: "提示",
            description: "请使用企业账号登录",
          });
        }
      } else {
        this.goMore("/login", "user", "jf");
      }
    },
    handleOk() {
      this.visible = false;
      const NoteParam = JSON.stringify(this.getDetailNoteParam);
      if (this.getAuditStatus == "0" || this.getAuditStatus == "null") {
        this.$router.push({
          path: "/sys/manage",
          query: {
            id: this.operatingIncomeScale,
            getDetailNoteParam: NoteParam,
          },
        });
      } else {
        message.success("本年度已填报");
      }
    },
    getBannerList() {
      this.getAction({
        url: getBannerInfo.pageList,
        params: { type: "home" },
      }).then((res) => {
        this.bannerData = res.records.reverse();
        // console.log(this.bannerData, "tupian111111111111");
      });
    },
    // getImg(imgUrl) {
    //   console.log(imgUrl,'+++++++++++++++++++')
    //   return file_service.imagesWeb(imgUrl);
    // },
    getImg(imgUrl) {
      if (!imgUrl) return "";
      if (
        typeof imgUrl === "string" &&
        (imgUrl.startsWith("http://") || imgUrl.startsWith("https://"))
      ) {
        return imgUrl;
      }
      if (file_service && file_service.imagesWeb) {
        return file_service.imagesWeb(imgUrl);
      }
      return "";
    },
    getWebInfo() {
      this.getAction({
        url: getWebInfo.detail,
        params: { id: 1 },
      }).then((res) => {
        this.webSiteInfo = res;
        this.all_logo = res.logo;
        this.$ls.set("all_logo", this.webSiteInfo.logo);
      });
    },
    getLink() {
      this.getAction({
        url: getWLinkPage.pageList,
      }).then((res) => {
        let arr = [];
        res.records.map((item) => {
          if (item.fname && item.furl) {
            arr.push(item);
          }
        });
        this.linkData = arr;
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getTongzhi()
      this.initSwiper();
      // this.getLink()
      this.getBannerList();
      this.getPolicyNotice();
      // this.getDate()
      // this.getNoticeDownInfo();
      this.getNoticeInfo();
      // this.getProjectReviewList();
      this.getFourData();
      if (ls.get("token") && ls.get("refresh_token")) {
        this.user.userName = this.$ls.get("userName");
        this.user.phoneNumber = this.$ls.get("phoneNumber");
      }
      if (ls.get("all_logo")) {
        this.all_logo = ls.get("all_logo");
      } else {
        this.getWebInfo();
      }
    });
  },
};
</script>

<style lang="less">
.indexCenter {
  width: 1200px;
  margin: 0 auto;
}
.index-top {
  .index-banner {
    height: 280px;
    background-image: url("../assets/home/home-banner.png");
    background-size: 100% 100%;
    .banner-top {
      padding-top: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      a {
        font-size: 16px;
        color: #104460;
      }
      a:hover {
        color: #40a9ff;
      }
      .lineBox {
        width: 1px;
        height: 10px;
        background: #34586b;
      }
    }
    .banner-user {
      color: #104460;
      .rightBox {
        padding: 5px 20px;
        float: right;
        display: flex;
        justify-content: space-around;
        align-items: center;
        // line-height: 92px;
        font-size: 16px;
        background-color: #f00;
        background: rgba(0, 89, 181, 0.1);
        border-radius: 50px;
        // opacity: 0.1;
        a {
          font-weight: 600;
        }

        .loginBox {
          // float: left;
          cursor: pointer;
        }

        .loginBox:hover {
          color: #fc550b;
        }

        .resigierBox {
          cursor: pointer;
          // float: left;
        }

        .resigierBox:hover {
          color: #fc550b;
        }
      }
    }

    .home-logo {
      margin-top: 60px;
      img {
        height: 52px;
      }
    }
  }

  .index-nav {
    background-color: #3264da;
    ul {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      font-size: 20px;
      color: #fff;
      li {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 60px;
        cursor: pointer;
        &::after {
          position: absolute;
          right: -1px;
          display: inline-block;
          content: "";
          width: 1px;
          height: 20px;
          background-color: rgba(255, 255, 255, 0.4);
        }
        a {
          display: block;
          width: 100%;
          height: 100%;
          text-align: center;
          color: #fff;
        }
      }
      li:last-child {
        &::after {
          display: none;
        }
      }
      .liSelect {
        position: relative;
        background-color: #0f4eb4;

        &::before {
          position: absolute;
          bottom: 0;
          display: block;
          content: "";
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-bottom: 6px solid #fff;
        }
      }
    }
  }
}

.module-title {
  margin: 52px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .module-title-left {
    font-size: 26px;
    font-weight: bold;
    &::before {
      display: inline-block;
      content: "";
      margin-right: 15px;
      width: 5px;
      height: 25px;
      background: #3264da;
      border-radius: 3px;
    }
  }
  .module-title-right {
    font-size: 16px;
    color: #999;
    cursor: pointer;
  }
}
.module1 {
  padding: 36px 0 8px;
  .module1-content {
    display: flex;
    justify-content: space-between;
  }
  .ant-carousel {
    width: 630px;
    height: 354px;
    background-color: #f0f8ff;
    img {
      width: 100%;
      height: 354px;
      // object-fit:cover;
    }
    :deep(.slick-dots) {
      right: 30px;
      bottom: 30px;
      width: auto;
      height: 10px;
      li {
        margin: 0 3px;
        button {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          border: 1px solid #ffffff;
          background-color: transparent;
        }
      }
      .slick-active {
        button {
          background-color: #fff;
        }
      }
    }
  }
  .module1-right {
    display: flex;
    flex-direction: column;
    width: 546px;
    .module1-right-top {
      display: flex;
      justify-content: space-between;
      li {
        width: 180px;
        margin-left: 2px;
        text-align: center;
        height: 60px;
        font-weight: bold;
        font-size: 18px;
        color: #666666;
        div {
          line-height: 54px;
          background-color: #e7efff;
          cursor: pointer;
        }
      }
      .module1LiSelect {
        background: url("../assets/home/module1Select.png");
        background-size: cover;
        div {
          color: #fff;
          background-color: transparent;
        }
      }
    }
    .module1-right-content {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin-top: 20px;
      width: 100%;
      li {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        cursor: pointer;
        width: 100%;

        .module1-title {
          flex: 1;
          display: flex;
          align-items: center;
          margin-right: 14px;
          overflow-y: hidden;
          &::before {
            margin-right: 10px;
            content: "";
            display: block;
            width: 6px;
            height: 6px;
            background: #3264da;
            border-radius: 50%;
          }
          p {
            max-width: 82%;
            font-size: 18px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          p:hover {
            color: #40a9ff;
          }
        }
        span {
          font-size: 18px;
          color: #666;
        }
        span:hover {
          color: #40a9ff;
        }
      }
      li:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.module2 {
  margin-bottom: 100px;
  .swiper-slide {
    display: flex;
    justify-content: space-between;
    .module2-item {
      display: flex;
      flex-direction: column;
      width: 285px;
      height: 320px;
      box-shadow: 2px 2px 8px 0px rgba(18, 93, 178, 0.1);
      border-radius: 0px 0px 4px 4px;
      cursor: pointer;
      background-color: #fff;

      .item-btm {
        flex: 1;
        padding: 28px 24px 0 24px;
        .item-title {
          font-size: 20px;
          font-weight: bold;
        }
        .item-text {
          margin-top: 16px;
          color: #666;
          font-size: 16px;
          line-height: 24px;
          width: 100%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .item-btn {
          margin: 16px 0 32px;
        }
        .item-btn2 {
          margin-top: 6px;
          display: none;
          .ant-btn {
            margin-right: 10px;
          }
        }
      }
    }
    .module2-item:hover {
      .item-btm {
        background-color: #3264da;
        color: #fff;

        .item-text {
          display: block;
          color: #fff;
          overflow: none;
        }
        .item-btn {
          display: none;
        }
        .item-btn2 {
          display: flex;
        }
      }
    }
  }
}

.module3 {
  border-top: 1px solid transparent;
  background-image: url("../assets/home/module3-bgi.jpg");
  background-size: cover;
  .module3-content-box {
    padding-bottom: 70px;
    display: flex;
    justify-content: space-between;
    .module3-item {
      display: flex;
      align-items: center;
      .item-right {
        margin-left: 20px;
        .module3-num {
          margin-bottom: 10px;
          display: flex;
          align-items: flex-end;
          .right-num {
            position: relative;
            font-size: 32px;
            &::after {
              position: absolute;
              left: 4px;
              bottom: 0;
              display: block;
              content: "";
              width: 25px;
              height: 2px;
              background: #3264da;
            }
          }
          span {
            font-size: 14px;
          }
        }
        p {
          color: #999;
        }
      }
    }
  }
}

.module4 {
  .menuBox {
    margin-bottom: 60px;
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    .smallMenuBox {
      padding: 42px 0 38px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      width: 224px;
      background-color: #fff;
      cursor: pointer;
      box-shadow: 0px 2px 8px 0px rgba(18, 93, 178, 0.1);
      border-radius: 4px;

      .module4-imgs {
        display: none;
      }
      .menuTitle {
        margin: 32px 0 22px;
        font-size: 20px;
        font-weight: bold;
        color: #000;
      }

      .titleInfo {
        margin-bottom: 24px;
        color: #666;
        font-size: 16px;
      }

      .showMoreBtn {
        .ant-btn {
          background-color: transparent;
          color: #40a9ff;
        }
      }
    }

    .smallMenuBox:hover {
      background-color: #3264da;
      .module4-img {
        display: none;
      }
      .module4-imgs {
        display: block;
      }
      .menuTitle {
        color: #fff;
      }
      .titleInfo {
        color: #fff;
      }
      .ant-btn {
        border-color: #fff;
        color: #fff;
      }
    }
  }
}

.xcimg {
  background: url(../assets/img/jr/bodyleftimg.png) center center no-repeat;
  background-size: cover;
  position: absolute;
  width: 300px;
  height: 400px;
  left: -350px;
  bottom: -430px;
}
.xcimgTop {
  background: url(../assets/img/jr/bodyright.jpg) top center no-repeat;
  background-size: cover;
  position: absolute;
  z-index: 1;
  width: 350px;
  height: 600px;
  right: -350px;
  top: -787px;
}
.xcbg {
  background: #fff;
  position: relative;
}
.login-form {
  padding: 30px 0;
  position: relative;
}
.tipphone {
  margin-bottom: 20px;
  color: red;
}
.SealServiceActive {
  display: block !important;
}

.codeBtnWordMark {
  width: 100%;
  height: 30px;
  background: rgba(136, 135, 135, 0.6);
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

:deep(.ant-btn) {
  color: #40a9ff;
  font-weight: 600;
  padding: 0 10px;
  border-color: #40a9ff;

  img {
    margin-right: 5px;
  }

  &:focus {
    background-color: #40a9ff;
    color: #fff;
    border-color: none;
    box-shadow: 1px 1px 5px 1px #a7a7a7;
  }

  &:hover {
    background-color: #40a9ff;
    color: #fff;
    border-color: none;
    box-shadow: 1px 1px 5px 1px #a7a7a7;
  }
}

.xcheader {
  /*background: url(../assets/img/jr/headerbg.png) center center no-repeat;
	background-size: cover;
	color:#fff;*/
}
.bannerBox {
  padding-top: 90px;
  position: relative;
  z-index: 2;
  width: 100%;

  :deep(.ant-carousel) {
    position: relative;
    width: 100%;
  }

  .bannerImg {
    width: 100%;
    height: 282px;

    img {
      width: 100%;
      object-fit: cover;
      height: 280px;
    }
  }
}

.linkBig {
  width: 100%;
  background-color: #fff;

  .linkBox {
    overflow: hidden;
    font-size: 16px;
    color: #333;
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;

    .leftLabel {
      float: left;
      width: 7%;
      font-weight: bold;
    }

    .rightBox {
      float: left;
      margin-left: 15px;
      width: 90%;
      // display: flex;
      // justify-items: start;
      // flex-wrap: wrap;

      .itemLink {
        float: left;
        margin-right: 30px;
        margin-bottom: 5px;
        color: #333;
        // text-decoration: underline;
      }

      .itemLink:hover {
        color: #40a9ff;
      }
    }
  }
}

.fixBox {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 300px;
  height: 150px;
  z-index: 999;

  .box {
    width: 100%;
    height: 100%;
    padding: 20px 15px;
    color: #fff;
    background-image: url("~@/assets/img/piaochuang.png");
    background-size: cover;
    background-position: center;
    cursor: pointer;

    .Xbtn {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-color: #cdcdcd;
      cursor: pointer;
      text-align: center;
      font-size: 12px;
      color: #333;
      opacity: 0.7;
    }

    .Xbtn:hover {
      opacity: 1;
    }

    .title {
      font-size: 16px;
      font-weight: bold;
    }

    .dataTime {
      margin: 10px 0 10px;
      font-size: 12px;
    }
  }
}

.rightNav {
  position: fixed;
  bottom: 50px;
  right: 0;
  width: 76px;
  background-color: #fefefe;
  box-shadow: 0px 2px 8px 0px rgba(18, 93, 178, 0.1);
  border-radius: 4px;
  .rightNav-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 76px;
    font-size: 12px;
    color: #333;
    cursor: pointer;
    border-radius: 4px;
    .rightNav-imgs {
      display: none;
    }
    img {
      height: 20px;
    }
    p {
      margin-top: 10px;
    }
  }
  .rightNav-item:hover {
    .rightNav-mask {
      display: flex;
    }
    .rightNav-img {
      display: none;
    }
    .rightNav-imgs {
      display: block;
    }
    color: #fff;
    background-color: #3264da;
  }
  .rightNav-mask {
    padding: 16px 20px;
    display: none;
    position: absolute;
    background-color: #fff;
    right: 100px;
    top: 0;
    box-shadow: 0px 2px 8px 0px rgba(18, 93, 178, 0.1);
    border-radius: 4px;
    color: #333;
    &::after {
      position: absolute;
      right: -16px;
      top: 30px;
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-left: 8px solid #fff;
      border-right: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-top: 8px solid transparent;
    }
    img {
      width: 84px;
      height: 84px;
      font-size: 14px;
    }
    p {
      white-space: nowrap;
      font-size: 16px;
    }
  }
}

:deep(.ant-btn) {
  color: #40a9ff;
  font-weight: 600;
  padding: 0 10px;
  border-color: #40a9ff;

  img {
    margin-right: 5px;
  }

  &:focus {
    background-color: #40a9ff;
    color: #fff;
    border-color: none;
    box-shadow: 1px 1px 5px 1px #a7a7a7;
  }

  &:hover {
    background-color: #40a9ff;
    color: #fff;
    border-color: none;
    box-shadow: 1px 1px 5px 1px #a7a7a7;
  }
}

.module1-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.el-carousel {
  width: 630px;
  margin: 0;
}

.swiper-title {
  position: absolute;
  bottom: 0px;
  left: 0px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  border-radius: 4px;
}


.service-swiper {
  width: 100%;
  overflow: hidden;
  margin-top: 20px;
  padding:0 0 20px 10px;
  position: relative; /* 为箭头定位做基础 */
}
.swiper-wrapper {
  display: flex;
  flex-wrap: nowrap; /* 强制横向排列，不换行 */
}
.swiper-slide {
  width:280px;
  flex-shrink: 0;
box-shadow: 0px 2px 8px 0 rgba(18, 93, 178, .1);
}
.module2-content {
  position: relative; /* 核心：让箭头基于这个容器定位 */
  width: 100%;
  max-width: 1200px; /* 与.module1-content保持一致 */
  margin: 0 auto;
}

/* 外部箭头样式：自定义外观，定位到容器两侧 */
.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 20; /* 确保箭头在轮播上方 */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #333;
}
/* 左箭头：定位到容器左侧 */
.prev-arrow {
  left: -60px;
}
/* 右箭头：定位到容器右侧 */
.next-arrow {
  right: -60px;
}
/* 箭头图标：伪类实现箭头符号 */
.prev-arrow::after {
  content: "<";
  font-weight: bold;
}
.next-arrow::after {
  content: ">";
  font-weight: bold;
}
</style>
